<template>
  <div style="padding:100px 8%;">
    <div class="tab-pane pt-3 active show" >
      <div class="insurance-editor">
        <div class="row">
          <div class="col-12">
            <h4>年期資料新增</h4>
            <form class="form">
              <div class="panel panel-form searchArea">
                <h4 class="text-green text-center">新增條件</h4>

                <!-- 型態 -->
                <div class="form-group row">
                  <label class="col-2 text-right">
                    <span class="text-red">＊</span>型態
                  </label>
                  <div class="col-9">
                    <div class="checkbox radio-inline ml-5">
                      <input type="checkbox" id="yearType-1" v-model="yearType1">
                      <label for="yearType-1">定期型</label>
                    </div>
                    <div class="checkbox radio-inline ml-5">
                      <input type="checkbox" id="yearType-2" v-model="yearType2">
                      <label for="yearType-2">歲滿型</label>
                    </div>
                  </div>
                </div>

                <!-- 年期 -->
                <div class="form-group row">
                  <label class="col-2 text-right">
                    <span class="text-red">＊</span>年期
                  </label>
                  <div class="col-9">
                    <input
                      type="number"
                      maxlength="3"
                      class="form-control form-control-inline"
                      :class="{ 'is-invalid': isError }"
                      v-model="yearInput"
                      @input="checkInput"
                      @blur="checkInput"
                    />
                  </div>
                </div>

                <div class="text-center">
                  <button
                    type="button"
                    class="btn btn-default"
                    @click="insertYearPeriod"
                  >
                    新增
                  </button>
                </div>
              </div>
            </form>
        </div>    

        <div class="col-12 mt-50" :class="{'section-loading': isLoading}">
          <table class="table datatable">
            <thead>
              <tr>
                <th style="width:50%" class="text-center">年期</th>
                <th style="width:50%" class="text-center">型態</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, i) in yearPeriodShowList" :key="`tradition-data-${i}`">
                <td>{{data.year}}</td>
                <td>{{data.typeName}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { commonMixin } from "@/mixins/common";
import { getYearPeriod, insertYearPeriod } from "@/service";
export default {
  name: "YearPeriodList",
  mixins: [commonMixin],
  data() {
    return {
      yearPeriodList: [],
      yearPeriodShowList: [],
      yearInput: "",
      yearType1: true,
      yearType2: true,
      isLoading: false,
      isError: false,
      typeObj: {
        1: "定期型",
        2: "歲滿型",
      },
    };
  },
  methods: {
    async init() {
      this.yearPeriodList = [];
      this.yearPeriodShowList = [];
      this.isError = false;
      this.yearInput = "";
      this.isLoading = true;

      await getYearPeriod(this.$store.state.userInfo.id).then((result) => {
        if (result.header && result.header.status == "200") {
          result.data.forEach((item) => {
            let yearPeriodData = {
              year: parseInt(item.prd.split("@")),
              type: item.prdtp,
              typeName: this.getTypeName(item.prdtp),
            };
            this.yearPeriodList.push(yearPeriodData);
          });
        } else {
          this.$toast.info({ title: result.header.message });
        }
        //排序
        this.yearPeriodList.sort(
          (itemA, itemB) => (itemA.type < itemB.type ? 1 : -1)
        );
        this.yearPeriodList.sort(
          (itemA, itemB) => (itemA.year > itemB.year ? 1 : -1)
        );
        this.yearPeriodShowList = this.yearPeriodList;
        this.isLoading = false;
      });
      this.switchShowType();
    },
    getTypeName(val) {
      return this.typeObj[val];
    },
    switchShowType() {
      this.yearPeriodShowList = this.yearPeriodList;
      if (!this.yearType1) {
        this.yearPeriodShowList = this.yearPeriodShowList.filter(
          (item) => item.type !== "1"
        );
      }
      if (!this.yearType2) {
        this.yearPeriodShowList = this.yearPeriodShowList.filter(
          (item) => item.type !== "2"
        );
      }
    },
    checkInput() {
      this.yearInput = this.yearInput.replace(
        /[A-Za-z<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\\s]/g,
        ""
      );
      if (this.stringBytes(this.yearInput, false, 3) > 3) {
        this.yearInput = this.yearInput.substring(
          0,
          this.stringBytes(this.yearInput, true, 3)
        );
      }
    },
    insertYearPeriod() {
      let reqList = [];
      this.isError = false;
      if (!this.yearType1 && !this.yearType2) {
        this.$toast.info({ title: "請選擇型態" });
        return;
      }
      if (!this.yearInput) {
        this.$toast.info({ title: "請輸入年期" });
        this.isError = true;
        return;
      } else if (parseInt(this.yearInput) === 0) {
        this.$toast.info({ title: "請輸入數字" });
        this.isError = true;
        return;
      }
      //定期型
      if (this.yearType1) {
        this.yearPeriodList.forEach((item) => {
          if (item.type == "1" && item.year == this.yearInput) {
            this.isError = true;
          }
        });
        if (this.isError) {
          this.$toast.info({ title: "已存在相同年期型態內容" });
          return;
        }
        reqList.push({
          prdtp: "1",
          prd: this.getPrd(this.yearInput, "1"),
        });
      }
      //歲滿期
      if (this.yearType2) {
        this.yearPeriodList.forEach((item) => {
          if (item.type == "2" && item.year == this.yearInput) {
            this.isError = true;
          }
        });
        if (this.isError) {
          this.$toast.info({ title: "已存在相同年期型態內容" });
          return;
        }
        reqList.push({
          prdtp: "2",
          prd: this.getPrd(this.yearInput, "2"),
        });
      }
      insertYearPeriod(this.$store.state.userInfo.id, reqList).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "新增成功" });
            this.init();
          } else {
            this.$toast.info({ title: result.header.message });
          }
        }
      );
    },
    getPrd(val, prdtp) {
      /**
       *1 若[型態]條件選擇”定期型”，
       *  1.1 [年期]欄位輸入的值為1碼，前面需補0至2碼，例：若輸入5，則insert至P023.prd的值為05
       *  1.2 [年期]欄位輸入的值為2~3碼，則直接insert，例：若輸入987，則insert至P023.prd的值為987
       *2 若[型態]條件選擇”歲滿期”且[年期]欄位輸入為1碼，
       *  2.1 [年期]欄位輸入的值前面需補0至2碼且後面需多加@，例：若輸入5，則insert至P023.prd的值為05@
       *3 若[型態]條件選擇”歲滿期”且[年期]欄位輸入為2~3碼，
       *  3.1[年期]欄位輸入的值後面需多加@，例：若輸入65，則insert至P023.prd的值為65@
       */
      let returnVal = "";
      let prdInt = parseInt(val);
      if (prdInt < 10) {
        returnVal = "0" + prdInt;
      } else {
        returnVal = prdInt.toString();
      }
      if (prdtp == "2") {
        returnVal = returnVal + "@";
      }
      return returnVal;
    },
  },
  watch: {
    yearType1: function() {
      this.switchShowType();
    },
    yearType2: function() {
      this.switchShowType();
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
.mt-50 {
  margin-top: 50px;
}
.ml-5 {
  margin-left: 5px !important;
}
.searchArea {
  border-color: #027a39;
  border-width: 3px;
  background-color: white;
}

.row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}
</style>
